import { Typography, Chip } from "@mui/material";
import { CommissionActionsPopover } from "./commission-actions-popover";

export const getCommissionsColumns = (onEditClick) => [
  {
    accessorKey: "id",
    header: () => <div>ID</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.id}</Typography>
    ),
  },
  {
    accessorKey: "name",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Commission Name</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.name ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "code",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Commission Code</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">{row.original.code ?? "—"}</Typography>
    ),
  },
  {
    accessorKey: "description",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Description</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.description ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "isActive",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => (
      <Chip
        label={row.original.isActive ? "Active" : "Inactive"}
        size="small"
        color={row.original.isActive ? "success" : "error"}
      />
    ),
  },
  {
    accessorKey: "createdBy",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Created By</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.createdBy ?? "—"}
      </Typography>
    ),
  },
  {
    accessorKey: "updatedAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Last Updated</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem">
        {row.original.updatedAt
          ? new Date(row.original.updatedAt).toLocaleDateString()
          : "—"}
      </Typography>
    ),
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => (
      <CommissionActionsPopover
        commission={row.original}
        onEditClick={onEditClick}
      />
    ),
  },
];